import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
} from "../types/authTypes";
import axiosInstance from "../../utils/setupAxios";

// Action Creators
export const loginRequest = () => ({
  type: LOGIN_REQUEST,
});

export const loginSuccess = (data) => ({
  type: LOGIN_SUCCESS,
  payload: {
    user: data.user,
    token: data.access_token,
    token_type: data.token_type,
    expires_in: data.expires_in,
  },
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const logout = () => ({
  type: LOGOUT,
});

export const getProfileRequest = () => ({
  type: GET_PROFILE_REQUEST,
});

export const getProfileSuccess = (user) => ({
  type: GET_PROFILE_SUCCESS,
  payload: user,
});

export const getProfileFailure = (error) => ({
  type: GET_PROFILE_FAILURE,
  payload: error,
});

// Login action
export const login = (credentials) => {
  return (dispatch) => {
    dispatch(loginRequest());

    const formData = new FormData();
    formData.append("email", credentials.email);
    formData.append("password", credentials.password);

    axiosInstance
      .post("/auth/login", formData)
      .then((response) => {
        if (response.data.success) {
          const { access_token, token_type, expires_in, user } =
            response.data.data;
          localStorage.setItem("access_token", access_token);
          localStorage.setItem("token_type", token_type);
          localStorage.setItem("expires_in", expires_in);
          localStorage.setItem("user", JSON.stringify(user));
          dispatch(loginSuccess(response.data.data));
        } else {
          dispatch(loginFailure(response.data.message || "Login failed"));
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch(loginFailure(error.response?.data?.message || "Login failed"));
      });
  };
};

// Get Profile action
export const getProfile = () => {
  return (dispatch) => {
    dispatch(getProfileRequest());

    axiosInstance
      .get("/user/me")
      .then((response) => {
        if (response.data.success) {
          dispatch(getProfileSuccess(response.data.data));
          localStorage.setItem("user", JSON.stringify(response.data.data));
        } else {
          dispatch(
            getProfileFailure(response.data.message || "Failed to get profile")
          );
        }
      })
      .catch((error) => {
        dispatch(
          getProfileFailure(
            error.response?.data?.message || "Failed to get profile"
          )
        );
      });
  };
};

// Logout action
export const logoutUser = () => {
  return (dispatch) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("token_type");
      localStorage.removeItem("expires_in");
      localStorage.removeItem("user");
      dispatch(logout());
    } else {
      dispatch(logout());
    }
  };
};
